import React from 'react'

type Props = {
  children: React.ReactNode | string
  size?: 'xs' | 's' | 'm'
}
const DescriptionText: React.FC<Props> = ({ children, size = 's' }) => {

  let sizeClass = ''
  switch(size) {
    case 'xs':
      sizeClass = 'text-xs sm:text-sm'
      break
    case 's':
      sizeClass = 'text-xs sm:text-md'
      break
    case 'm':
      sizeClass = 'text-md sm:text-base'
      break
    default:
      sizeClass = 'text-xs sm:text-md'
  }

  return (
    <p className={`${sizeClass} text-black font-light whitespace-pre-line`}>
      {children}
    </p>
  )
}

export default DescriptionText
